
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component
export default class AppLoading extends Vue {
    @Prop({ default: false }) private visible?: boolean
}
